export enum enmPriceType {
    PER_PERSON = 0,
    PER_ROOM = 1
}